import { ReactNode } from 'react'

import { IconArrowUpRight, SimpleModal } from '@sequencehq/core-components'
import { useNavigate } from 'react-router-dom'

type Props = {
  isOpen: boolean
  confirmTitleText: string
  onClose: () => void
  children: ReactNode
}

/**
 * Blocking dialog shown when an action can't proceed because tax categories
 * have not been mapped to Avalara tax codes; sends the user to the tax
 * settings page to configure the mappings.
 */
export const AvalaraBlocker = ({
  isOpen,
  confirmTitleText,
  onClose,
  children
}: Props) => {
  const navigate = useNavigate()

  return (
    <SimpleModal
      isOpen={isOpen}
      variant="dialog"
      data-testid="common.avalaraBlocker"
      title={confirmTitleText}
      cancelButtonText="Cancel"
      onClose={onClose}
      submitButtonText="Manage tax categories"
      submitButtonTrailingIcon={
        <IconArrowUpRight style={{ display: 'inline', marginLeft: '4px' }} />
      }
      onSubmit={() => {
        navigate('/settings/tax-rates')
        return true
      }}
    >
      {children}
    </SimpleModal>
  )
}
